import React from "react";
import { MenuItem } from "@mui/material";
import { useTheme } from "@emotion/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { Select } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledSelect = styled(
  Select,
  {}
)(({ theme, customProps }) => ({
  height: "2em !important",
  width: "100px",
  borderRadius: theme.size[4],
  border: "1px solid #ccc",
  "&.MuiInputBase-root": {
    backgroundColor: theme.palette.form.fieldBackground,
    // "&:hover": {
    //   borderColor: "transparent",
    // },
  },
  "& .MuiInputBase-root": {
    height: "2em !important",
    borderRadius: theme.size[4],
  },

  "& .MuiOutlinedInput-input": {
    padding: "0px 14px",
  },
  "& .MuiSelect-select": {
    display: "flex",
    height: "inherit",
    alignItems: "center",
  },

  "& .MuiSelect-select.MuiSelect-outlined": {
    fontSize: "13px !important",
    color: theme.palette.form.text,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent !important",
  },
}));

function SingleSelectDropdown({
  label,
  type,
  value,
  placeholder = "option",
  options,
  isRequired = false,
  isDisabled = false,
  componentId,
  categoryId,
  suffix = "",
  onChange = () => {},
}) {
  const theme = useTheme();
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: theme.size[8],
        }}
      >
        <StyledSelect
          displayEmpty
          value={value}
          onChange={(e) => {
            onChange(categoryId, componentId, e.target.value);
          }}
          inputProps={{
            "aria-label": "Without label",
            MenuProps: {
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.form.fieldBackground,
                  color: theme.palette.form.text,
                  boxShadow:
                    "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                },
              },
            },
          }}
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            backgroundColor: isDisabled
              ? `${theme.palette.rapidInfra.disabledGrey2} !Important`
              : `${theme.palette.rapid.lightGrey} !Important`, // Set background color to grey
            border: "none",
            ".MuiSvgIcon-root ": {
              fill: `${theme.palette.form.text} !important`,
              opacity: 0.5,
            },
          }}
          placeholder={"Enter Value Type"}
          renderValue={(selected) => {
            if (["", undefined, null].includes(selected)) {
              return <p style={{ opacity: 0.5 }}>Select {placeholder}</p>;
            }
            return selected;
          }}
          disabled={isDisabled}
        >
          {options?.length > 0 ? (
            options?.map((optionValue) => (
              <MenuItem
                key={optionValue.property_value}
                value={optionValue.property_value}
                sx={{
                  fontSize: theme.size[12],

                  // "&.Mui-focused": {
                  //   backgroundColor: "transparent", // Disable background highlight
                  // },
                }}
              >
                {optionValue.property_value}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="" disabled>
              No options
            </MenuItem>
          )}
        </StyledSelect>
        {suffix !== "" && (
          <span
            style={{
              fontSize: theme.size[12],
              fontWeight: theme.fontWeight[500],
              marginLeft: theme.size[8],
              whiteSpace: "nowrap",
              color: theme.palette.rapidInfra.text,
            }}
          >
            {suffix}
          </span>
        )}
      </div>
    </>
  );
}

export default SingleSelectDropdown;
